const config = {
    // basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs, also don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '',
    defaultPath: '/',
    fontFamily: `Square`,
    borderRadius: 12,
    API_SERVER: 'http://localhost:5000/api/'
};

export default config;
